module.exports = __webpack_public_path__ + "assets/img/block-hover-27b3a754.png";